import { render, staticRenderFns } from "./StartupCostsOverTimeChart.vue?vue&type=template&id=07e39c32"
import script from "./StartupCostsOverTimeChart.vue?vue&type=script&lang=js"
export * from "./StartupCostsOverTimeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports